import * as React from 'react';
import { Formik, Form } from 'formik';

import NotifyHOC from '../../../HOC/Notifications';
import TextField from '../../common/textField';

import * as projectService from '../../../services/project.service';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalTitle
} from '../../common/modal';
import { duplicateProjectValidationSchema } from '../../common/validation/validationSchema';
import { HealthProblem } from '@nexxt/common/types';

interface IDuplicateProjectProps {
    onClose: () => void;
    duplicatedProject: any;
    toastNotification: any;
    duplicateProjectToggle: () => void;
    handleSubmit: (values, actions) => void;
    projectHealth: HealthProblem[];
    checkProjectHealth: (id: number) => Promise<void>;
    clearProjectHealth: () => void;
}

interface IDuplicateProjectState {
    isRequesting: boolean;
}

class DuplicateProjectModal extends React.Component<
    IDuplicateProjectProps,
    IDuplicateProjectState
> {
    constructor(props) {
        super(props);
        this.state = {
            isRequesting: false
        };
    }

    async componentDidMount() {
        await this.props.checkProjectHealth(this.props.duplicatedProject.id);
    }

    componentWillUnmount(): void {
        console.log('clear health');
        this.props.clearProjectHealth();
    }
    render() {
        const { isRequesting } = this.state;
        const { duplicatedProject } = this.props;
        return (
            <Modal className="modal__heightauto" isOpen={true}>
                <ModalHeader onClose={this.props.onClose}>
                    <ModalTitle>Duplicate project</ModalTitle>
                </ModalHeader>
                <Formik
                    initialValues={{
                        projectName: `${duplicatedProject.name} copy`
                    }}
                    validationSchema={duplicateProjectValidationSchema}
                    onSubmit={(values, actions) => {
                        this.props.handleSubmit(values, actions);
                    }}
                    render={({
                        values,
                        touched,
                        handleChange,
                        handleBlur,
                        errors,
                        dirty,
                        isSubmitting
                    }) => (
                        <Form>
                            <ModalBody>
                                {duplicatedProject?.hasCustomLogic && (
                                    <div style={{ fontSize: 12 }}>
                                        <p style={{ color: 'red' }}>
                                            <b>WARNING</b>
                                        </p>
                                        <p>
                                            This project has custom logic which
                                            will NOT be transferred to the
                                            duplicated project. Please make sure
                                            to update the questions with custom
                                            logic before launching the study.
                                        </p>
                                    </div>
                                )}
                                <TextField
                                    type="text"
                                    name="projectName"
                                    value={values.projectName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Project Name"
                                    label="Project Name"
                                    errorMessage={errors.projectName}
                                    touchedValue={touched.projectName}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <button
                                    className="btn btn--sm btn--transparent m-r-10"
                                    disabled={isSubmitting || isRequesting}
                                    onClick={() => this.props.onClose()}
                                >
                                    Cancel
                                </button>
                                <button
                                    disabled={isSubmitting || isRequesting}
                                    className="btn btn--sm btn--green"
                                    type="submit"
                                >
                                    {isSubmitting || isRequesting
                                        ? 'Duplicating project'
                                        : 'Duplicate project'}
                                </button>
                            </ModalFooter>
                        </Form>
                    )}
                />
            </Modal>
        );
    }
}

export default NotifyHOC(DuplicateProjectModal);
